import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'nomoh_cookie_consent';

type ConsentStatus = 'accepted' | 'rejected' | null;

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  private _status = signal<ConsentStatus>(this._loadFromStorage());

  /** Estado atual do consentimento: 'accepted', 'rejected' ou null (não decidido) */
  $status = this._status.asReadonly();

  aceitar(): void {
    this._status.set('accepted');
    localStorage.setItem(STORAGE_KEY, 'accepted');
  }

  rejeitar(): void {
    this._status.set('rejected');
    localStorage.setItem(STORAGE_KEY, 'rejected');
  }

  private _loadFromStorage(): ConsentStatus {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'accepted') return 'accepted';
    if (stored === 'rejected') return 'rejected';
    return null;
  }
}
